import { ImageGalleryTemplatePropsInterface } from 'common/module/image-gallery/template-props.interface';
import { preactConnectStore } from 'common/module/preact/connect-store';

import { GalleryScrollComponentPropsInterface } from './component-props.interface';
import { GalleryScrollTemplate } from './template';
import { GalleryScrollViewStore } from './view-store';
import { GalleryScrollViewStoreFactory } from './view-store.factory';

export const GalleryScrollComponent = preactConnectStore<
  GalleryScrollViewStore,
  ImageGalleryTemplatePropsInterface,
  GalleryScrollComponentPropsInterface
>(
  GalleryScrollViewStoreFactory,
  (store, { props }) => ({
    ...store.getState(),
    indicatorComponent: props.indicatorComponent,
    whatsappShown: props.whatsappShown,
  }),
  (store, { props }) => store.initialize(props)
)(GalleryScrollTemplate);
